<div *ngIf="!control.element.visibility || (control.element.isVisible === true)" [style.padding-left.px]="control.element.paddingLeft">
  <ng-container [ngSwitch]="control.element.type">
    <div *ngSwitchCase="'title'">
      <h1 style="color: #000;">{{control.element.label}}</h1>
    </div>
    <div *ngSwitchCase="'html'">
      <p style="color: black" [innerHTML]="control.element.label"></p>
    </div>
    <div *ngSwitchCase="'file'">
      <p style="color: black" [innerHTML]="control.element.label"></p>
      <app-file-upload-v2 [fileControl]="control"></app-file-upload-v2>
    </div>
    <div *ngSwitchCase="'text'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <input type="text" [id]="control.element.id" [formControl]="control.AsTyped" [class]="formHelper.getValidIndicator(control)" [placeholder]="control.element.placeholder" [readOnly]="control.element.readOnly === true" [ngbTooltip]="getTooltip(control)">
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'textarea'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <textarea [rows]="3" [maxlength]="control.element.maxLength" [id]="control.element.id" [formControl]="control.AsTyped" [class]="formHelper.getValidIndicator(control)" [placeholder]="control.element.placeholder" [readOnly]="control.element.readOnly === true" [ngbTooltip]="getTooltip(control)"></textarea>
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'ain'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <input type="text" [id]="control.element.id" [formControl]="control.AsTyped" [class]="formHelper.getValidIndicator(control)" [placeholder]="control.element.placeholder" appNumericSplitter [splitterType]="SplitterType.AIN" [readOnly]="control.element.readOnly === true">
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'zip'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <input type="text" [id]="control.element.id" [formControl]="control.AsTyped" [class]="formHelper.getValidIndicator(control)" [placeholder]="control.element.placeholder" appNumericSplitter [splitterType]="SplitterType.ZIP" [readOnly]="control.element.readOnly === true">
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'ssn'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <app-ssn-input [control]="control"></app-ssn-input>
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'phone'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <input type="text" [id]="control.element.id" [formControl]="control.AsTyped" [class]="formHelper.getValidIndicator(control)" [placeholder]="control.element.placeholder" autocomplete="tel" [readonly]="control.element.readOnly === true" appNumericSplitter [splitterType]="SplitterType.PHONE"  [ngbTooltip]="getTooltip(control)">
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'radio'">
      <p style="color: black; margin-bottom: 0">{{ control.element.label }} <span class="color-red">{{ control.isRequired() ? '*' : '' }}</span></p>
      <div *ngFor="let option of control.element.options">
        <div class="form-check">
          <input type="radio" [name]="control.element.id" [id]="option.id" [formControl]="control.AsTyped" class="form-check-input" [value]="option.id">
          <label class="form-check-label" style="color: black" [for]="option.id">{{ option.label }}</label>
        </div>
      </div>
    </div>
    <div *ngSwitchCase="'checkbox'">
      <div class="form-check">
        <input [id]="control.element.id" class="form-check-input" type="checkbox" value="" [formControl]="control.AsTyped">
        <label class="form-check-label" [for]="control.element.id" style="color: black">{{ control.element.option }}</label>
        <app-control-error-list [control]="control"></app-control-error-list>
      </div>
    </div>
    <div *ngSwitchCase="'date'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <input type="date" [formControl]="control.AsTyped" [id]="control.element.id" [class]="formHelper.getValidIndicator(control)">
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'radio_large'">
      <app-radio-lg-button [formGroup]="formGroup" [control]="control"></app-radio-lg-button>
    </div>
    <div *ngSwitchCase="'select-state'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <app-select-state [control]="control" [formGroup]="formGroup"></app-select-state>
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'currency'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <input [formControl]="control.AsTyped" [id]="control.element.id" currencyMask class="form-control" [options]="{prefix: '$', thousands: ',', decimal: '.', allowNegative: false, allowZero: true, align: 'right'}" />
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'number'">
      <app-dynamic-form-label [arrayIndex]="arrayIndex" [control]="control"></app-dynamic-form-label>
      <input type="number" [formControl]="control.AsTyped" [id]="control.element.id" [class]="formHelper.getValidIndicator(control)" [readOnly]="control.element.readOnly === true" [ngbTooltip]="getTooltip(control)">
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'address_lookup'" style="padding-bottom: 10px">
      <p style="color: black" [innerHTML]="control.element.label"></p>
      <app-address-search [control]="control" [viewModel]="viewModel"></app-address-search>
    </div>
    <div *ngSwitchCase="'existing_address'">
      <app-existing-address [control]="control" [viewModel]="viewModel"></app-existing-address>
    </div>
    <div *ngSwitchCase="'button_reset_fields'">
      <app-button-reset-fields [control]="control" [controlCache]="controlCache"></app-button-reset-fields>
    </div>
    <div *ngSwitchCase="'validation'">
      <app-control-error-list [control]="control"></app-control-error-list>
    </div>
    <div *ngSwitchCase="'grid'">
      <app-control-grid [control]="control" [pageFormGroup]="formGroup" [viewModel]="viewModel" [controls]="controlCache"></app-control-grid>
    </div>
    <div *ngSwitchDefault>
      <p>Unknown control of type {{control.element.type}}</p>
    </div>
  </ng-container>
</div>
